// extracted by mini-css-extract-plugin
export default {"pronouns":"NDWNldDsJF_P3zdTdZKR"};